import FilterModal from './FilterModal';
import { useDispatch } from 'react-redux';
import { setModalId, usePublicState } from '@/store/slices/publicSlice';
import Search from '@/components/categories/Search';
import { useLazyGetOngoingOrdersReportFileQuery } from '@/store/services/reports';
import FilterBtn from '../SharedComponents/FilterBtn';
import ExportBtn from '../SharedComponents/ExportBtn';
import { useOrdersBudgetFilters } from '@/store/slices/reportFiltersSlice';

export function Filters() {
  const dispatch = useDispatch();
  const filters = useOrdersBudgetFilters();
  const { search } = usePublicState();

  const searchValue = search?.budgetReportSearch || '';

  return (
    <div className="flex items-center justify-between flex-col md:flex-row gap-4">
      <Search searchName="budgetReportSearch" />

      <div className="flex items-center gap-4">
        <FilterBtn
          onClick={() => {
            dispatch(setModalId({ id: 'ORDERS_BUDGET_REPORT_MODAL' }));
          }}
        />

        <ExportBtn
          useQueryHook={useLazyGetOngoingOrdersReportFileQuery}
          filters={{ ...filters, search: searchValue }}
        />
      </div>

      <FilterModal />
    </div>
  );
}

